export var AgentChannel;
(function (AgentChannel) {
    AgentChannel[AgentChannel["NONE"] = 0] = "NONE";
    AgentChannel[AgentChannel["TICKET"] = 10] = "TICKET";
    AgentChannel[AgentChannel["CALL_CENTER"] = 20] = "CALL_CENTER";
    AgentChannel[AgentChannel["CHAT"] = 30] = "CHAT";
    AgentChannel[AgentChannel["FACEBOOK"] = 40] = "FACEBOOK";
    AgentChannel[AgentChannel["WHATSAPP"] = 50] = "WHATSAPP";
    AgentChannel[AgentChannel["SMS"] = 60] = "SMS";
    AgentChannel[AgentChannel["TWITTER"] = 80] = "TWITTER";
})(AgentChannel || (AgentChannel = {}));
//# sourceMappingURL=agent-channel.enum.js.map